import {putResolve, takeLeading, select, throttle} from 'redux-saga/effects';

import {
	SERVER_CONFIG,
	SERVER_CONFIG_BY_RESTAURANT,
	SERVER_CONFIG_BY_RESTAURANT_FAILURE,
	SERVER_CONFIG_BY_RESTAURANT_REQUEST,
	SERVER_CONFIG_BY_RESTAURANT_SUCCESS,
	SERVER_CONFIG_FAILURE,
	SERVER_CONFIG_REQUEST,
	SERVER_CONFIG_SUCCESS,
} from 'new-constants/api.constants';
import Platform from '../platform';
import {getStartupParams} from 'helpers/startup-params.helper';
//import ClientTracker from 'utils/ClientTracker';
import {getServerConfig, getServerConfigByRestaurant} from 'new-actions/api.actions.ts';
import {getCurrentAppIdSelector, getCurrentServerConfig} from '../selectors';
import {START} from "../constants/app-state.constants";

function isServerConfigNotFetched(currentServerConfig) {
	if (!currentServerConfig) {
		return true;
	}

	return false;
}

function isServerConfigOutdated(customer, currentServerConfig) {
	if (!customer.currentCustomer?.appConfigVersion) {
		return false;
	}

	if (
		Platform.isSetRestaurant &&
		getStartupParams() &&
		currentServerConfig &&
		currentServerConfig.restaurantId !== getStartupParams().id
	) {
		return true;
	}

	if (
		currentServerConfig &&
		customer.currentCustomer &&
		customer.currentCustomer.appId === currentServerConfig.appId &&
		customer.currentCustomer.appConfigVersion > currentServerConfig.configVersion
	) {
		return true;
	}

	return false;
}

function* getServerConfigIfNecessary() {
	const state = yield select();
	const {customer, serverConfig, appState, connectivity, fetchProgress, fetchError} = state;

	if (
		fetchProgress[SERVER_CONFIG] ||
		fetchProgress[SERVER_CONFIG_BY_RESTAURANT] ||
		fetchError[SERVER_CONFIG] ||
		fetchError[SERVER_CONFIG_BY_RESTAURANT]
	) {
		return;
	}

	const currentServerConfig = getCurrentServerConfig(state);
	const currentAppId = getCurrentAppIdSelector(state);

	if (
		(isServerConfigNotFetched(currentServerConfig) || isServerConfigOutdated(customer, currentServerConfig)) &&
		connectivity.isOnline !== false
	) {
		if (Platform.isSetRestaurant) {
			yield putResolve(getServerConfigByRestaurant(getStartupParams().id));

			const startupParams = getStartupParams();

			//ClientTracker.setInfoMessage('SetRestaurant mode data: ' + startupParams ? JSON.stringify(startupParams) : '{}');
		} else if(!!currentAppId){
			yield putResolve(getServerConfig(currentAppId));

			var updateMessage = `App config update detected. Clearing local data. Local version = ${serverConfig.config &&
			serverConfig.config.configVersion}, customer.appConfigVersion: ${customer.currentCustomer &&
			customer.currentCustomer.appConfigVersion}`;
			console.log(updateMessage);
			//ClientTracker.setInfoMessage(updateMessage);
		}
	}
}

function* refreshRestaurantConfigIfNecessary() {
	const state = yield select();
	const {customer} = state;
	const currentServerConfig = getCurrentServerConfig(state);

	if (Platform.isSetRestaurant &&
		!isServerConfigNotFetched(currentServerConfig) &&
		!isServerConfigOutdated(customer, currentServerConfig)) {
		yield putResolve(getServerConfigByRestaurant(getStartupParams().id));
	}
}

export const serverConfigUpdaterSaga = function* serverConfigUpdaterSaga() {
	yield throttle(
		2500,
		[
			action =>
				![
					SERVER_CONFIG_REQUEST,
					SERVER_CONFIG_SUCCESS,
					SERVER_CONFIG_FAILURE,
					SERVER_CONFIG_BY_RESTAURANT_REQUEST,
					SERVER_CONFIG_BY_RESTAURANT_SUCCESS,
					SERVER_CONFIG_BY_RESTAURANT_FAILURE,
				].includes(action.type),
		],
		getServerConfigIfNecessary
	);
	yield takeLeading([START], refreshRestaurantConfigIfNecessary)
};
